import { render, staticRenderFns } from "./learn9.vue?vue&type=template&id=aeefd910&scoped=true"
import script from "./learn9.vue?vue&type=script&lang=js"
export * from "./learn9.vue?vue&type=script&lang=js"
import style0 from "./learn9.vue?vue&type=style&index=0&id=aeefd910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeefd910",
  null
  
)

export default component.exports